'use strict';
define([
    'angular',
    'modules/seospider/exam/analysis/detail/summary/summary.controller'
],function(angular,SinglePageSummaryCtrl){
    var app=angular.module('app.seospider.exam.analysis.detail.summary', []);
    app.controller('SinglePageSummaryCtrl',SinglePageSummaryCtrl);
    return app;
});